import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDriverDashboardRoutes = Loadable(
  './DriverDashboardRoutes',
  () => import(/* webpackChunkName: "DriverDashboard" */ './DriverDashboardRoutes'),
  () => [(require as any).resolveWeak('./DriverDashboardRoutes')]
);
